import React, { useEffect } from 'react';
import { SafeAreaView, StatusBar, StyleSheet } from 'react-native';
import { Provider } from 'react-redux';
import { store } from './src/store/store';
import MainNavigator from './src/components/MainNavigator';
import backgroundHealthCheck from './src/services/backgroundHealthCheck';
import { APP_CONFIG } from './src/config/version';

function App(): React.JSX.Element {
  useEffect(() => {
    // 根据APP_CONFIG.ENABLE_HEALTH_CHECK配置启动后台健康检查服务
    if (APP_CONFIG.ENABLE_HEALTH_CHECK) {
      console.log(`🚀 Starting background health check service (Backend: ${APP_CONFIG.BACKEND_TARGET})`);
      backgroundHealthCheck.start();
    } else {
      console.log('🔧 Background health check service is disabled');
    }

    // 清理函数
    return () => {
      backgroundHealthCheck.stop();
    };
  }, []);

  return (
    <Provider store={store}>
      <SafeAreaView style={styles.container}>
        <StatusBar barStyle="dark-content" backgroundColor="#f0f0f0" />
        <MainNavigator />
      </SafeAreaView>
    </Provider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f0f0f0',
  },
});

export default App;
